import * as React from 'react';
import { SegmentRatioBar } from '../../../designSystem/graphs/SegmentRatioBar';
import { SelectionSummary } from '../../../amorg-common';
import { colors } from '../../../designSystem/colors/color';
import { graphLegendDefaultText } from '../../../designSystem/graphs/GraphLegend';

type AnswerRatioBarGraphProps = {
    data:SelectionSummary,
    legend:'none' |'regular' | 'classic',
    heightPx?:number,
    showValueText?:boolean
}
export function AnswerRatioBarGraph(props:AnswerRatioBarGraphProps):JSX.Element
{

    const {value1Count, value2Count, value3Count, value4Count, value5Count} = props.data;
    const total = value1Count + value2Count + value3Count + value4Count + value5Count;

    return (
        <SegmentRatioBar legend={props.legend} heightPx={props.heightPx} showValueText={props.showValueText}
            data={[
                { value:value1Count, valueText:getAnswerRationGraphValueText(value1Count, total), color:colors.graphs.survey.answers.veryDissatisfied, legendText:'Meget uenig ' + graphLegendDefaultText(value1Count, total) },
                { value:value2Count, valueText:getAnswerRationGraphValueText(value2Count, total), color:colors.graphs.survey.answers.dissatisfied, legendText:'Uenig ' + graphLegendDefaultText(value2Count, total) },
                { value:value3Count, valueText:getAnswerRationGraphValueText(value3Count, total), color:colors.graphs.survey.answers.neutral, legendText:'Neutral ' + graphLegendDefaultText(value3Count, total) },
                { value:value4Count, valueText:getAnswerRationGraphValueText(value4Count, total), color:colors.graphs.survey.answers.satisfied, legendText:'Enig ' + graphLegendDefaultText(value4Count, total) },
                { value:value5Count, valueText:getAnswerRationGraphValueText(value5Count, total), color:colors.graphs.survey.answers.verySatisfied, legendText:'Meget enig ' + graphLegendDefaultText(value5Count, total) }
            ]}/>
    );
}


export function getAnswerRationGraphValueText(value:number, total:number):React.ReactNode | undefined
{
    return <span style={{color:'#eaeaea'}}>{Math.round(value/total*100)}%</span>
}